<template>
  <div class="member_current_period_container">
    <div class="member_current_period_container_inner">
      <div class="boxImg" :style="{width: (item.temImg.imgSize? item.temImg.imgSize: 0)  + '%',cursor: item.temImg.url? 'pointer': 'auto'}" v-for="item in currentImgList" :key="item.temImg.id">
          <img :title="item.temImg.url" :src="lang === 'zh'? (item.temImg.cnImg? item.temImg.cnImg: item.temImg.enImg): (item.temImg.enImg? item.temImg.enImg: item.temImg.cnImg)" @click="linkAdress(item)" alt="本期主打">
      </div>
    </div>
    <!-- 弹框： -->
    <myself-dialog :dialogFlag="dialogFlag" @hideMask="hideMask" width="500px" p_lr="0px">
      <div class="mask_son_inner_container ql-container ql-snow">
        <div class="ql-editor show_container" v-html="dialogHTML"></div>
      </div>
    </myself-dialog>
    <div class="gift-box" v-if="giftBoxShow">
      <img width="100%" v-if="giftType == 3" src="../../../assets/img/member/membergift/upgradeGift/wlqzg_djs_bg.jpg"/>
      <img width="100%" v-else src="../../../assets/img/member/membergift/upgradeGift/no_member_djs_bg.jpg"/>
      <div class="box upgrade">
        <div class="close" @click="closeGift">X</div>
      </div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
//菜单储存器
import menuStore from "@store/menuStore/menuStore.js";
import userStore from "@/store/userStore/userStore.js";
export default {
  components: {
    "myself-dialog": () => import("@/components/modal/myselfdialog/myselfdialog.vue")
  },
  data() {
    return {
      currentImgList: [],
      dialogFlag: false,
      dialogHTML: "",
      giftBoxShow: false,
      giftType: ''
    };
  },
  methods: {
    async getCurrentPeriodList() {
      try {
        this.$dominosloading.show();
         let {data: result} = await this.$post('getTemplateByGroup', {"group": "featured"});
        this.$dominosloading.hide();
        if (result.code !== 200) return;
        this.currentImgList = result.data || [];
        this.currentImgList = this.currentImgList.filter(item => {
          if (item.temImg && (item.temImg.cnImg || item.temImg.enImg)) {
            return item;
          }
        });
      } catch(err) {
        console.log(err);
      }
    },
    linkAdress(item) {
      if(item && item.temImg){
        //判断是否需要登录
        if(item.temImg.needLogin&&!this.isLogin){
            menuStore.commit('loginModalOpen', false);
            menuStore.commit('loginModalOpen', true);
        } else if(item.richText && Object.keys(item.richText).length && item.richText.chText1){
            this.dialogHTML = item.richText.chText1;
            this.dialogFlag = true;
        } else if(item.temImg.url){
          //判断是不是打开升级礼和回馈礼
          if(item.temImg.url.indexOf('{gift}')>-1){
            // console.log('item.temImg.url', item, userStore.getters.userInfo)
            this.giftType = userStore.getters.userInfo.giftType;
            if (this.giftType == 2) {
              menuStore.commit('IsgiftModalStatus', false);
              menuStore.commit('IsgiftModalStatus', true);
            } else {
              this.giftBoxShow = true;
            }
          } //判断是不是外部地址
          else if(item.temImg.url.indexOf('http')>-1){
            location.href = item.temImg.url;
          }else{
            this.$router.push(item.temImg.url);
          } 
        }
        try {
          clab_tracker.ready(function(){
            this.track('c_check_main_campaign', {'c_buttonName': item.code, 'c_buttonId': item.id});
          });
        } catch (error) {
          
        }
      }
    },
    hideMask() {
      this.dialogFlag = false;
    },
    closeGift() {
      this.giftBoxShow = false;
    }
  },
  mounted() {
    this.getCurrentPeriodList();
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    isLogin() {
      return userStore.getters.isLogin;
    },
  }
};
</script>

<style lang="scss" scoped>
.member_current_period_container {
  padding: 10px 100px 50px;
  background-color: #fff;
  text-align: left;
  .member_current_period_container_inner {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .boxImg{
      margin-top: 14px;
    }
    img {
      height: 100%;
      width: 100%;
      display: block;
      &:nth-of-type(1) {
        margin-top: 0px;
      }
    }
  }
}

.mask_son_inner_container {
  max-height: 500px;
  overflow: auto;
  padding-top:16px;
  padding-bottom: 30px;
}

.gift-box {
  position: fixed;
  width: 340px;
  min-height: 600px;
  z-index: 12;
  top: 2%;
  left: 50%;
  transform: translateX(-50%);

  .close {
    position: absolute;
    background: #de002a;
    right: -6px;
    top: -6px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 10px;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
  }
}
</style>